import React, { Component } from "react";
import { FileUploader } from "react-drag-drop-files";
import { Add1Icon, CloudIcon, EditIcon } from "../../assets/icons";
import SelectTagsModal from "./SelectTagsModal";
import { LuPlay, LuPause, LuPlaySquare } from "react-icons/lu";
import { observer } from "mobx-react";
import voiceStore from "../../stores/voiceStore";

const fileTypes = ["mp3", "wav", "mp4", "ogg", "webm"];
const maxFileSize = 100;

const AddNewTalentStep2 = observer(
  class AddNewTalentStep2 extends Component {
    constructor(props) {
      super(props);
      this.state = {
        files: [],
        fileUploadError: "",
        editingIndex: null,
        newName: "",
        showModal: false,
        currentFileIndex: null,
        videoModalVisible: false,
        videoModalFile: null,
        currentPlayingIndex: null,
      };

      this.audioRefs = {};
    }

    handleChange = (files) => {
      this.setState({ fileUploadError: null });

      const validFiles = Array.from(files).filter(
        (file) => file.size <= maxFileSize * 1024 * 1024
      );

      if (validFiles.length !== files.length) {
        alert("Some files exceed the maximum size of 100MB and were not added.");
      }

      const newFiles = validFiles.map((file, index) => ({
        fileName: `${file.name.split(".")[0]}_${this.state.files.length + index + 1}`,
        fileType: file.type,
        voiceFile: file,
        tags: {
          gender: null,
          languages: [],
          accents: [],
          styles: [],
          ageGroups: [],
          additionalTags: [],
        },
      }));

      this.setState((prevState) => ({
        files: [...prevState.files, ...newFiles],
        fileUploadError: "",
      }));
    };

    handleEdit = (index) => {
      this.setState({
        editingIndex: index,
        newName: this.state.files[index].fileName,
      });
    };

    handleNameChange = (event) => {
      this.setState({ newName: event.target.value });
    };

    handleSave = () => {
      const { files, editingIndex, newName } = this.state;
      files[editingIndex].fileName = newName;
      this.setState({
        files,
        editingIndex: null,
        newName: "",
      });
    };

    handleAddTags = (index) => {
      this.setState({ showModal: true, currentFileIndex: index });
    };

    handleSaveTags = (tags) => {
      const { files, currentFileIndex } = this.state;
      if (currentFileIndex === null) 
      {
         const updatedFiles = files.map((file, index) => {
            return { ...file, tags: tags };
         });
          this.setState({
          files: updatedFiles,
          showModal: false,
          currentFileIndex: null,
        });
        
      }else
      {
        const updatedFiles = files.map((file, index) => {
          if (index === currentFileIndex) {
            return { ...file, tags: tags };
          }
          return file;
        });
        this.setState({
          files: updatedFiles,
          showModal: false,
          currentFileIndex: null,
        });
        
      }
     
    };

    handlePlayPause = (index) => {
      const audioElement = this.audioRefs[index];

      if (
        this.state.currentPlayingIndex !== null &&
        this.state.currentPlayingIndex !== index
      ) {
        const otherAudio = this.audioRefs[this.state.currentPlayingIndex];
        otherAudio.pause();
      }

      if (audioElement.paused) {
        audioElement.play();
        this.setState({ currentPlayingIndex: index });
      } else {
        audioElement.pause();
        this.setState({ currentPlayingIndex: null });
      }
    };

    componentDidMount() {
      this.setState({ ...voiceStore.step2Values });
    }
    handleAddBulkTags = () => {
      this.setState({ showModal: true, currentFileIndex: null });
    };

    render() {
      const { files, editingIndex, newName, showModal, currentFileIndex } =
        this.state;

      return (
        <div className="flex flex-1 flex-col z-10">
          <div className="flex flex-col mb-6">
            <div className="h-[1px] w-full bg-[#DDE1E6] mt-6 hidden lg:flex"></div>
            <span className="font-normal text-base lg:text-lg text-[#21272A] my-6">
              Add voice sample
            </span>
            <FileUploader
              handleChange={this.handleChange}
              name="file"
              types={fileTypes}
              maxSize={maxFileSize}
              multiple
              uploadedLabel="Uploaded Successfully!"
              onTypeError={(err) => {
                this.setState({ fileUploadError: err });
              }}
              children={
                <div className="flex flex-col bg-[#F2F4F8] py-3 lg:py-0 items-center">
                  <img className="w-11 lg:w-12" src={CloudIcon} alt="Cloud" />
                  <span className="font-medium text-xs lg:text-sm text-[#292D32] hidden lg:flex">
                    Choose files or drag & drop them here
                  </span>
                  <span className="font-medium text-xs lg:text-sm text-[#292D32] flex lg:hidden">
                    Choose files
                  </span>
                  <span className="font-medium text-xs lg:text-sm text-[#A9ACB4] text-center">{`${fileTypes.map(
                    (type) => type
                  )} format only, up to ${maxFileSize}MB`}</span>
                  <span className="text-red-600 animate-pulse mt-3">
                    {this.state.fileUploadError}
                  </span>
                </div>
              }
            />
          </div>

          <div>
            {files.length > 0 && (
              <table className="flex flex-1 flex-col shrink-0 w-full bg-transparent border text-center border-[#DDE1E6]">
                <thead className="flex flex-1">
                  <tr className="bg-[#E8E9ED] flex flex-1 flex-row justify-between">
                    <th className="font-normal text-xs lg:text-sm text-[#121619] p-3">
                      Name
                    </th>
                    <th className="font-normal text-xs lg:text-sm text-[#121619] p-3">
                      Tags
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {files.map((file, index) => (
                    <tr
                      key={index}
                      className="border-b border-[#DDE1E6] flex flex-1 flex-row justify-around "
                    >
                      <td className="p-4 flex flex-1 items-center gap-x-4">
                        <div>
                          {file?.fileType.includes("audio") ? (
                            <>
                              <button
                                onClick={() => this.handlePlayPause(index)}
                                className="text-xl"
                              >
                                {this.state.currentPlayingIndex === index &&
                                !this.audioRefs[index].paused ? (
                                  <LuPause></LuPause>
                                ) : (
                                  <LuPlay></LuPlay>
                                )}
                              </button>
                              <audio
                                ref={(ref) => (this.audioRefs[index] = ref)}
                              >
                                <source
                                  src={URL.createObjectURL(file.voiceFile)}
                                />
                              </audio>
                            </>
                          ) : (
                            <button
                              onClick={() => {
                                voiceStore.setVideoModal({
                                  fileName: file.fileName,
                                  video: URL.createObjectURL(file.voiceFile),
                                });
                              }}
                              className="text-xl"
                            >
                              <LuPlaySquare></LuPlaySquare>
                            </button>
                          )}
                        </div>

                        <div>
                          {" "}
                          {editingIndex === index ? (
                            <input
                              type="text"
                              value={newName}
                              onChange={this.handleNameChange}
                              onBlur={this.handleSave}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  this.handleSave();
                                }
                              }}
                              autoFocus
                              className="flex-1"
                            />
                          ) : (
                            <div className="flex items-start">
                              <span className="font-normal text-sm text-[#21272A]">
                                {file.fileName}
                              </span>
                              <img
                                className="w-4 cursor-pointer ml-2"
                                src={EditIcon}
                                alt="Edit"
                                onClick={() => this.handleEdit(index)}
                              />
                            </div>
                          )}
                        </div>
                      </td>

                      <td className="p-4 flex flex-1  flex-wrap justify-between items-center">
                        <div className="flex flex-1  flex-wrap gap-2">
                          {file.tags.gender?.value && (
                            <span
                              key={file.tags.gender.value}
                              className="font-normal text-[10px] lg:text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md"
                            >
                              {file.tags.gender.label}
                            </span>
                          )}
                          {file.tags.languages.map((tag) => (
                            <span
                              key={tag.value}
                              className="font-normal text-[10px] lg:text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md"
                            >
                              {tag.label}
                            </span>
                          ))}

                          {file.tags.accents.map((tag) => (
                            <span
                              key={tag.value}
                              className="font-normal text-[10px] lg:text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md"
                            >
                              {tag.label}
                            </span>
                          ))}
                          {file.tags.ageGroups.map((tag) => (
                            <span
                              key={tag.value}
                              className="font-normal text-[10px] lg:text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md"
                            >
                              {tag.label}
                            </span>
                          ))}
                          {file.tags.styles.map((tag) => (
                            <span
                              key={tag.value}
                              className="font-normal text-[10px] lg:text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md"
                            >
                              {tag.label}
                            </span>
                          ))}
                          {file.tags.additionalTags.map((tag) => (
                            <span
                              key={tag.value}
                              className="font-normal text-[10px] lg:text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md"
                            >
                              {tag.label}
                            </span>
                          ))}
                        </div>
                        <button
                          className="flex items-center"
                          onClick={() => this.handleAddTags(index)}
                        >
                          <img className="w-3" src={Add1Icon} alt="Add" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          {showModal && (
            <SelectTagsModal
              onSave={this.handleSaveTags}
              onClose={() => this.setState({ showModal: false })}
              selectedTags={
                currentFileIndex !== null ? files[currentFileIndex].tags : {}
              }
            />
          )}
           
          <div className="mt-14 flex justify-end gap-2 pb-10">
             {files.length > 0 && (<button  
                  className="relative w-40 h-10 bg-black text-white rounded-lg overflow-hidden"
                 onClick={() => 
                    {
                     this.handleAddBulkTags();
                    }
                }
                 >
                   Bulk Edit
                   
                </button>)}
          
            <button
              className="text-[#130D0D] font-medium text-base px-6 py-2 rounded-md border-[2px] border-[#130D0D] absolute lg:flex lg:relative lg:bottom-0 lg:left-0 bottom-5 left-5"
              onClick={() => {
                voiceStore.setStep2Values(this.state);
                voiceStore.prevStep();
              }}
            >
              Back
            </button>
            <button
              className="text-white font-medium text-base px-6 py-2 rounded-md bg-[#130D0D] absolute lg:flex lg:relative lg:bottom-0 lg:right-0 bottom-5 right-5"
              onClick={() => {
                voiceStore.setStep2Values(this.state);
                voiceStore.nextStep();
              }}
            >
              Next
            </button>
          </div>
          
        </div>
      );
    }
  }
);

export default AddNewTalentStep2;
